import videojs from 'video.js';
import { uint8ArrayToBase64 } from './utils';

const getContentId = (drm: any) => () => {
  return drm.fairplay.extensions.releasePid;
};

const getCertificate = (drm: any) => (_: any, callback: any) => {
  // Make sure the certificate URL is HTTPS
  const certificateUrl = new URL(drm.fairplay.certificate_url);
  certificateUrl.protocol = 'https';
  // @ts-ignore
  videojs.xhr(
    {
      method: 'GET',
      url: certificateUrl.href,
      responseType: 'arraybuffer',
    },
    // @ts-ignore
    (error, _, responseBody) => {
      if (error) {
        callback(error);
        return;
      }

      const certificate = new Uint8Array(responseBody);

      callback(null, certificate);
    }
  );
};

const getLicense =
  (drm: any) => (_: any, contentId: any, keyMessage: any, callback: any) => {
    // @ts-ignore
    videojs.xhr(
      {
        method: 'POST',
        url: drm.fairplay.license_server_url,
        responseType: drm.fairplay.license_server_request_content_type,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          getFairplayLicense: {
            spcMessage: uint8ArrayToBase64(keyMessage),
            releasePid: contentId,
          },
        }),
      },
      // @ts-ignore
      (error, _, responseBody) => {
        if (error) {
          callback(error);
          return;
        }

        const {
          getFairplayLicenseResponse: { ckcResponse },
        } = JSON.parse(responseBody);

        const license = new Uint8Array(
          atob(ckcResponse)
            .split('')
            .map((c) => c.charCodeAt(0))
        );

        callback(null, license);
      }
    );
  };

export default function drmSetup(player: any, drm: any) {
  const emeOptions = {
    keySystems: {
      'com.apple.fps.1_0': {
        getContentId: getContentId(drm),
        getCertificate: getCertificate(drm),
        getLicense: getLicense(drm),
      },
    },
  };
  player.eme(emeOptions);
  return {};
}
